import React from 'react';

// Shared segmented toggle to switch between the two Rate Shopper surfaces:
//   • Rate Shopper (shopping / operational)  → screen 'rate-shopper'
//   • Mapping (competitor room & meal config) → screen 'rate-shopper-mapping'
// Rendered identically at the top of both screens so the control is consistent and
// the highlighted segment always shows which surface you're on. Replaces the two
// separate nav entries with one menu item + this in-screen switch.
//
// Props:
//   mode: 'shopper' | 'mapping'  — which surface is currently shown
//   onSwitch(screenKey)          — navigate (App.js setScreen)
const OPTIONS = [
  ['rate-shopper', 'Rate Shopper', 'shopper'],
  ['rate-shopper-mapping', 'Mapping', 'mapping'],
];

function RateShopperModeToggle({ mode, onSwitch }) {
  return (
    <div role="tablist" aria-label="Rate Shopper views"
      style={{ display: 'inline-flex', background: 'var(--theme-surface-2, #f1f5f9)', border: '1px solid var(--theme-border, #e5e7eb)', borderRadius: 10, padding: 3, gap: 2, marginBottom: 14 }}>
      {OPTIONS.map(([key, label, m]) => {
        const active = mode === m;
        return (
          <button key={key} type="button" role="tab" aria-selected={active} tabIndex={active ? 0 : -1}
            onClick={() => { if (!active && typeof onSwitch === 'function') onSwitch(key); }}
            style={{
              border: 'none', cursor: active ? 'default' : 'pointer', padding: '7px 16px', borderRadius: 8,
              fontSize: 13, fontWeight: active ? 700 : 500, transition: 'background 0.15s, color 0.15s',
              background: active ? 'var(--theme-primary, #0d8f83)' : 'transparent',
              color: active ? '#fff' : 'var(--theme-text-muted, #64748b)',
            }}>
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default RateShopperModeToggle;
